import { advancedFlowSchema_ } from "@redotech/redo-model/advanced-flow/advanced-flow-db-parser";
import * as z from "zod/v4";

export const updateAdvancedFlow = {
  name: "updateAdvancedFlow" as const,
  input: z.object({
    flowId: z.string(),
    updates: z.object({
      name: z.string().optional(),
      description: z.string().optional(),
      steps: advancedFlowSchema_.shape.steps.optional(),
      enabled: z.boolean().optional(),
      index: z.number().optional(),
    }),
  }),
  output: z.object({ success: z.boolean() }),
};
